import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CARD_CATEGORIES } from '@/lib/utils/constants/cards';

interface CategorySelectorProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  isEditing?: boolean;
}

export function CategorySelector({
  selectedCategory,
  onCategoryChange,
  isEditing = false
}: CategorySelectorProps) {
  if (isEditing) return null;

  return (
    <div className="space-y-2">
      <Label>Category</Label>
      <Select
        value={selectedCategory}
        onValueChange={onCategoryChange}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select a category" />
        </SelectTrigger>
        <SelectContent>
          {Object.entries(CARD_CATEGORIES).map(([key, category]) => (
            <SelectItem key={key} value={key}>
              {category.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
} 